import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { AppState } from '../app.state';
import {
    LoadFriendsListAction, 
    LoadFriendsListFailedAction, 
    LoadFriendsListSucceededAction, 
    SearchFriendsListAction, 
    SendFriendRequestAction
} from './friendList.actions';
import { FriendsListState } from './friendList.state';
import { filter, pluck, map, switchMap, take } from 'rxjs/operators';


@Injectable()
export class FriendsListStoreDispatcher {
    constructor(private store: Store<AppState>) { }

    public loadFriendsList() {
        this.store.dispatch(new LoadFriendsListAction());
    }

    public searchFriends(query: string): void {
        if (query == '') {
            this.loadFriendsList();
        } else {
            this.store.dispatch(new SearchFriendsListAction(query));
        }
    }

    public sendFriendRequest(userID: string) {
        this.store.dispatch(new SendFriendRequestAction(userID));
    }

    /**
     * Get state property functions
     */

    public getState(): Observable<FriendsListState> {
        return this.store.select((state: AppState) => state.friendsList).pipe(filter(friendsListState => friendsListState != null));
    }

    public getFriends(): Observable < any[] > {
        return this.getState().pipe(filter(friendsListState => friendsListState.friends != null), pluck('friends'));
    }
}
